var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrm2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 47.46 53.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Sfumatura_senza_nome_1383-2);\n      }\n\n      .cls-2 {\n        fill: url(#Sfumatura_senza_nome_1382-3);\n      }\n\n      .cls-3 {\n        fill: url(#Sfumatura_senza_nome_1382);\n      }\n\n      .cls-4 {\n        fill: url(#Sfumatura_senza_nome_1382-4);\n      }\n\n      .cls-5 {\n        fill: url(#Sfumatura_senza_nome_1382-2);\n      }\n\n      .cls-6 {\n        fill: url(#Sfumatura_senza_nome_1383);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_1382",
    "data-name": "Sfumatura senza nome 1382",
    x1: 37.93,
    y1: 8.58,
    x2: 39.21,
    y2: 31.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ebebf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#2db7ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2da3af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#2d839d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2d5783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d4b7c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_1383",
    "data-name": "Sfumatura senza nome 1383",
    x1: 27.25,
    y1: 43.11,
    x2: 46.45,
    y2: 28.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d4b7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2d5783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2d839d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#2da3af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2db7ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ebebf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_1382-2",
    "data-name": "Sfumatura senza nome 1382",
    x1: 26.47,
    y1: 44.03,
    x2: 13.89,
    y2: 39.1,
    xlinkHref: "#Sfumatura_senza_nome_1382"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_1382-3",
    "data-name": "Sfumatura senza nome 1382",
    x1: 11.9,
    y1: 34.16,
    x2: 5.78,
    y2: 21.91,
    xlinkHref: "#Sfumatura_senza_nome_1382"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_1382-4",
    "data-name": "Sfumatura senza nome 1382",
    x1: 3.06,
    y1: 22.49,
    x2: 20.7,
    y2: 10.64,
    xlinkHref: "#Sfumatura_senza_nome_1382"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_1383-2",
    "data-name": "Sfumatura senza nome 1383",
    x1: 38.47,
    y1: 17.68,
    x2: 15.86,
    y2: 5.14,
    xlinkHref: "#Sfumatura_senza_nome_1383"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.04,41.28c.88-.51,1.43-1.44,1.43-2.46V14.83c0-1.01-.54-1.95-1.43-2.46l-13.53-7.77c3.7,2.13,4.36,5.13,4.53,10.37v11.85c0,3.39-1.3,6.78-3.9,9.36-.84.84-1.77,1.54-2.76,2.1l5.21,8.98,10.44-6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M22.3,53.28c.88.51,1.97.51,2.85,0l20.88-11.99c.88-.51,1.43-1.44,1.43-2.46v-15.55c0,4.25-2.28,6.32-6.76,9.09l-10.32,5.93c-2.95,1.69-6.55,2.27-10.1,1.32-1.15-.31-2.22-.76-3.21-1.32l-5.21,8.98,10.44,6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M0,38.82c0,1.01.54,1.95,1.43,2.46l20.88,11.99c.88.51,1.97.51,2.85,0l13.53-7.77c-3.7,2.13-6.64,1.19-11.3-1.28l-10.32-5.93c-2.95-1.69-5.25-4.51-6.2-8.04-.31-1.15-.45-2.3-.45-3.43H0v11.99Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.43,12.38c-.88.51-1.43,1.44-1.43,2.46v23.99c0,1.01.54,1.95,1.43,2.46l13.53,7.77c-3.7-2.13-4.36-5.13-4.53-10.38v-11.85c0-3.39,1.3-6.78,3.9-9.36.84-.84,1.77-1.54,2.76-2.1l-5.21-8.98L1.43,12.38Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.16.38c-.88-.51-1.97-.51-2.85,0L1.43,12.38c-.88.51-1.43,1.44-1.43,2.46v15.55c0-4.25,2.28-6.32,6.76-9.09l10.32-5.93c2.95-1.69,6.55-2.27,10.1-1.32,1.15.31,2.22.76,3.21,1.32l2.12-10.76L25.16.38Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.58,23.4c.31,1.14.45,2.28.45,3.4v-11.83c-.17-5.25-.83-8.25-4.53-10.37L25.16.38c-.88-.51-1.97-.51-2.85,0l-13.53,7.77c3.7-2.13,6.64-1.19,11.3,1.28l10.32,5.93c2.95,1.69,5.25,4.51,6.2,8.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm2);
export default __webpack_public_path__ + "static/media/CRM-2.9e2628eb5bd8e3ff52b86e7d2a9da045.svg";
export { ForwardRef as ReactComponent };